import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useProductStore } from './productStore';
import { useNotificationStore } from './notificationStore';
import type { ProductWithDetails } from '../types';

export const useImportStore = defineStore('import', () => {
  const productStore = useProductStore();
  const notificationStore = useNotificationStore();
  
  const importing = ref(false);
  const progress = ref(0);
  const currentProduct = ref('');
  const error = ref<string | null>(null);

  const importProducts = async (products: ProductWithDetails[]) => {
    if (products.length === 0) {
      notificationStore.error('No hay productos para importar');
      return false;
    }

    importing.value = true;
    progress.value = 0;
    error.value = null;
    const startTime = Date.now();

    try {
      const total = products.length;
      
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        currentProduct.value = product.Nombre;
        
        await productStore.addProduct(product);
        
        progress.value = Math.round(((i + 1) / total) * 100);
        
        // Calcular tiempo estimado restante
        const elapsed = Date.now() - startTime;
        const timePerItem = elapsed / (i + 1);
        const remaining = total - (i + 1);
        const estimatedMs = timePerItem * remaining;
        
        if (estimatedMs > 0) {
          const estimatedTimeLeft = estimatedMs < 60000 
            ? Math.round(estimatedMs / 1000) + " segundos"
            : Math.round(estimatedMs / 60000) + " minutos";
            
          currentProduct.value = product.Nombre + " (" + estimatedTimeLeft + " restantes)";
        }
      }

      notificationStore.success("Se importaron " + products.length + " productos correctamente");
      return true;
    } catch (err) {
      console.error('Error importing products:', err);
      error.value = err instanceof Error ? err.message : 'Error al importar productos';
      notificationStore.error('Error al importar productos');
      return false;
    } finally {
      importing.value = false;
      progress.value = 0;
      currentProduct.value = '';
    }
  };

  return {
    importing,
    progress,
    currentProduct,
    error,
    importProducts
  };
});